<mat-dialog-content >
<div id="w3l-appointment">
<section class="w3l-form-25">
  <div class="form-inner-cont">
    <div class="w3l-form-25">
        <h1>{{'Nurse Assessment' | translate }}</h1>
    </div>
  </div>

  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">

            <div class="accounts" style="left: 50px;">
              <div class="appointment-form-field">
                <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

                <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
                <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
                <label style="font-size: large;font-weight: bold;left: 190px;">{{patientname}}</label>
              </div>
              <ul>
                <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

                <label style="font-size: large;font-weight: bold;">Date :{{patdate}}</label>
                <label style="font-size: large;font-weight: bold;">     </label>
                <label style="font-size: large;font-weight: bold;">Time :01:00 pm</label>
              </ul>
            </div>
        </div>
    </div>
    <BR>
    <div class="appointment-form-field">
      <label style = "width: 10%;">Date </label>
      <input type="date" name="site" [(ngModel)]="visdate" style="width: 20%;" required="" />
      <label style = "width: 20%;"></label>
      <label style = "width: 10%;">Location </label>

      <select id="visitlocation" name="visitlocation"   [(ngModel)]="visitlocation" style="width: 33.5%;background-color:  rgb(187, 203, 238);"  required>
          <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
      </select>
  </div>
  </section>
  <mat-accordion class="example-headers-align" multi >
    <!--************* Basic **********-->
    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
      <mat-expansion-panel-header style="width:104%;">
        <mat-panel-title style="width:100%;height: 50px; font-size: 130%; font-weight: bold; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-home" aria-hidden="true">
           {{'Assessment Data' | translate}}
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon></mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="appointment-form-field" style="width: 100%;">
        <label style="width: 10%;">Weight/الوزن</label>
        <input type="text" name="weight" [(ngModel)]="weight" required="" style="width: 8%;" placeholder="Weight"/>
        <label style="width: 2%;"></label>
        <label style="width: 10%;">Height/الطول</label>

        <input type="text" name="height" [(ngModel)]="height" required="" style="width: 8%;" placeholder="Height"/>
        <label style="width: 2%;"></label>
        <label style="width: 15%;">Blood Pressure/ضغط </label>

        <input type="text" name="pressure" [(ngModel)]="pressure" required="" style="width: 15%;" placeholder="Blood Pressure"/>
          <label style="width: 2%;"></label>
          <label style="width: 2%;"></label>
          <label style="width: 10%;">Pulse/النبض</label>

          <input type="text" name="pulse" [(ngModel)]="pulse" required="" style="width: 8%;" placeholder="Pulse"/>
          <label style="width: 2%;"></label>
          <label style="width: 10%;">Temp/الحرارة</label>
          <input type="text" name="temp" [(ngModel)]="temp"  required="" style="width: 8%;" placeholder="Temp"/>

      </div>
      <BR>
      <div class="appointment-form-field">
        <label style="width: 6.5%;">Notes </label>
        <span class="fa fa-balance-scale" style="cursor: grab;"   aria-hidden="true"></span>
        <input type="text" name="weight"  required=""  [(ngModel)]="nursenote"   style="width: 90%;" placeholder=""/>
      </div>
      <BR>
        <div >
          <input type="checkbox" name="concet" [(ngModel)]="patientConsent" style="width: 25px;height: 25px;" (change)="Change_color()" required="" />
          <label style="width: 6.5%;color: {{wk_color}};font-size: 150%;font-weight: bold;">Patient Consent</label>
        </div>
<BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Save_Data()">{{ 'Submit' | translate }}</button>

    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back"  (click)="Close_Data()">{{ 'Exit' | translate }}</button>

    <label style="width: 25%;"></label>
  </form>
    </mat-expansion-panel>
    <!--************* Past Medical History **********-->
    <!-- <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title style="width:100%;height: 50px; font-size: 130%; font-weight: bold; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-map-marker" aria-hidden="true">
           {{'Past Medical History' | translate}}
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon></mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form action="/action_page.php" >

        <div class="appointment-form-field">
            <label   style="width: 35%;height:30px; color: {{MHColor}};font-weight: bold; font-size: larger;font-family: Arial;">• Diabetes / سكر</label>
            <label style="color:{{MHColor}}"   >Since     </label>
            <input type="number" name="Sinced" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "diabetessince" >
              <select id="TypeDay" name="Typeday" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "diabetesdays">
                <option value="">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
              </select>

        </div>

        <div >
        <div class="appointment-form-field">
              <label style="width: 35%;height:30px; color: {{MHColor1}};font-weight: bold; font-size: larger;font-family: Arial;">• Hypertension/ضغط الدم</label>
              <label style="color:{{MHColor1}}"  >Since     </label>
              <input type="number" name="Sincehy" placeholder="0" style="width: 7%;" required [(ngModel)]= "haypersince">
              <select id="TypehHiber" name="TypehHiber" style="width: 8%; background-color:  rgb(187, 203, 238);" required [(ngModel)]= "hayperdays">
                <option value="">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
              </select>

    </div>
    </div>

        <div >
        <div class="appointment-form-field">
            <label for="History3" style="width: 35%;height:30px;color:  {{MHColor2}};font-weight: bold; font-size: larger;font-family: Arial;">• Hepatitis /التهاب الكبد</label>
            <label style="color:  {{MHColor2}}" >Since     </label>

            <input type="number" name="Sinceh" placeholder="0"  style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "hepasince">
              <select id="Hepatites" name="Hepatites" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "hepadays">
                <option value="">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
              </select>
          </div>
        </div>

        <div>
          <div class="appointment-form-field">

              <label for="History4" style="width: 35%;height:30px;color:  {{MHColor3}};font-weight: bold; font-size: larger;font-family: Arial;" >• Bilharzia /البلهارسيا</label>
              <label style="color:  {{MHColor3}}"  >Since     </label>

              <input type="number" name="Sinceb" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "bilhsince">
              <select id="Hepatites2" name="Hepatites2" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "bilhdays">
                <option value="">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
              </select>

          </div>
        </div>

        <div >
        <div class="appointment-form-field">
                <label style="width: 35%;height:30px; color: {{MHColor4}};font-weight: bold; font-size: larger;font-family: Arial;">• Cardiac / القلب</label>
                <label style="color:  {{MHColor4}}"  >Since     </label>

                <input type="number" name="Sincec" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.1cm;" required [(ngModel)]= "cardsince">
                <select id="TypeCardiac" name="TypeCardiac" style="width: 8%;background-color:  rgb(187, 203, 238);" required  [(ngModel)]= "carddays">
                  <option value="">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
              </select>


        </div>
        </div>

        <div  >
          <div class="appointment-form-field">
              <label style="width: 35%;height:30px; color: {{MHColor5}};font-weight: bold; font-size: larger;font-family: Arial;">• Auto immune / المناعة</label>
              <label style="color: {{MHColor5}}"  >Since     </label>
              <input type="number" name="Sincea" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.08cm;" required [(ngModel)]= "autosince">
              <select id="TypeAuto" name="TypeAuto" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "autodays">
                <option value="0">Select*</option>
                <option value="Day">Day</option>
                <option value="Month">Month</option>
                <option value="Year">Year</option>
            </select>
          </div>
        </div>


        <div >
        <div class="appointment-form-field">
            <label style="width: 35%;height:30px; color: {{MHColor6}};font-weight: bold; font-size: larger;font-family: Arial;">• Allergy / حساسية</label>
            <label style="color: {{MHColor6}}" >Since     </label>

            <input type="number" name="Sinceal" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.08cm;" required [(ngModel)]= "allergysince">
            <select id="TypeAuto1" name="TypeAuto1" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "allergydays">
              <option value="0">Select*</option>
              <option value="Day">Day</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
          </select>
        </div>
        </div>

      <div >
        <div class="appointment-form-field">
              <label style="width: 35%;height:30px; color: {{MHColor7}};font-weight: bold; font-size: larger;font-family: Arial;">• Others / أخرى</label>
              <label style ="color: {{MHColor7}}"  >Since     </label>

              <input type="number" name="Since88" placeholder="0" style="width: 7%;border-width: 0.02cm;padding-top: 0.079cm;" required [(ngModel)]= "otherssince" >

              <select id="TypeOthers1" name="TypeOthers1" style="width: 8%;background-color:  rgb(187, 203, 238);" required [(ngModel)]= "othersdays">
                <option value="0">Select*</option>
                <option value="1">Day</option>
                <option value="2">Month</option>
                <option value="3">Year</option>
            </select>

        </div>
      </div>



      </form>
    </mat-expansion-panel>
    <mat-divider></mat-divider> -->

  </mat-accordion>
</section>
</div>
</mat-dialog-content>
